var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-range-picker',{key:_vm.id,ref:"rangeDate",staticStyle:{"width":"100%"},attrs:{"format":"YYYY-MM-DD HH:mm:ss","showTime":{ hideDisabledOptions:true },"showToday":""},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }